import React, { useState, useCallback, useEffect } from 'react'
import useSWR from 'swr'
import { fetcher, staticOptions } from 'src/lib/core/api-client'
import { SettingItem } from 'src/components/settings/SettingsList'
import Link from 'next/link'
import { SettingsConfig, SettingConfig } from 'src/lib/types/settings'
import { Briefcase, Thermometer, FileText } from 'react-feather'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { apiURI } from 'src/lib/utils/constants'

const BillingUsage: React.FC = ({}) => {
  const [billingSettings, setBillingSettings] = useState<SettingsConfig>([])

  const { setLoaderProperties } = useLoader()
  const { data: settingsResponse, isValidating: settingsResponseValidated } = useSWR(
    ['/md/merchants/integration-config', apiURI.FLO_KRATOS_CHECKOUT],
    ([url, baseURI]) => fetcher(url, baseURI),
    staticOptions
  )

  useEffect(() => {
    if (settingsResponseValidated) {
      setLoaderProperties({ isLoaderVisible: true, message: 'Loading' })
      return
    }
    setLoaderProperties({ isLoaderVisible: false })
  }, [settingsResponseValidated])

  useEffect(() => {
    if (!Boolean(settingsResponse) || Boolean(settingsResponseValidated)) return
    parseBillingSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsResponse, settingsResponseValidated])

  const isBillingDetailsConfigured = useCallback(() => {
    const data = (settingsResponse as [])?.find((setting: any) => setting.type === 'business-details')
    if (!data) return false
    return Boolean(data['is_configured'])
  }, [settingsResponse])

  const parseBillingSettings = () => {
    const modifiedBillingConfig: SettingsConfig = []
    modifiedBillingConfig.push({
      type: 'billing-usage',
      icon: FileText,
      label: 'View invoices and pay bill',
      isDisabled: false,
      is_mandatory: false,
      subType: 'invoice-bill',
      isRedirect: true,
      redirectURL: 'https://books.zoho.in/portal/shopflo'
    })
    setBillingSettings(modifiedBillingConfig)
  }

  return (
    <div className='flex flex-row w-full gap-6'>
      <ul className='flex flex-col w-full gap-2'>
        {billingSettings.map((item: SettingConfig) => {
          return (
            <>
              {!Boolean(item?.isDisabled) ? (
                <Link
                  href={
                    Boolean(item?.isDisabled)
                      ? '#'
                      : Boolean(item?.isRedirect) && item?.redirectURL
                      ? item?.redirectURL
                      : `/settings/${item?.type}${Boolean(item?.subType) ? '/' + item?.subType : ''}`
                  }
                  key={item?.type + Boolean(item?.subType) ? '-' + item?.subType : ''}
                  target={Boolean(item?.isRedirect) ? '_blank' : ''}
                  passHref
                >
                  <li key={item?.type + Boolean(item?.subType) ? '-' + item?.subType : ''}>
                    <SettingItem
                      key={item?.label}
                      type={item?.type ?? ''}
                      icon={item?.icon}
                      tagText={item?.tagText ?? ''}
                      is_mandatory={item?.is_mandatory ?? false}
                      label={item?.label}
                      is_configured={item?.is_configured ?? false}
                      permissionId={item?.permissionId}
                      isDisabled={item?.isDisabled}
                      isRedirect={item?.isRedirect ?? false}
                    />
                  </li>
                </Link>
              ) : (
                <li key={item?.type + Boolean(item?.subType) ? '-' + item?.subType : ''} className='cursor-not-allowed'>
                  <SettingItem
                    key={item?.label}
                    type={item?.type ?? ''}
                    icon={item?.icon}
                    tagText={item?.tagText ?? ''}
                    is_mandatory={item?.is_mandatory ?? false}
                    label={item?.label}
                    is_configured={item?.is_configured ?? false}
                    permissionId={item?.permissionId}
                    isDisabled={item?.isDisabled}
                    isRedirect={item?.isRedirect ?? false}
                  />
                </li>
              )}
            </>
          )
        })}
      </ul>
    </div>
  )
}

export default BillingUsage
